module.exports = __webpack_public_path__ + "img/DSC_1135.b03c2a02.jpg";